class NovaRecipeGallery extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-recipe-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-recipe-dot]'));
    this.currentIndex = 0;

    if (this.slides.length < 2) return;

    this.querySelector('[data-recipe-previous]')?.addEventListener('click', () => this.show(this.currentIndex - 1));
    this.querySelector('[data-recipe-next]')?.addEventListener('click', () => this.show(this.currentIndex + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
  }

  show(index) {
    this.currentIndex = (index + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== this.currentIndex;
    });

    this.dots.forEach((dot, dotIndex) => {
      dot.setAttribute('aria-current', dotIndex === this.currentIndex ? 'true' : 'false');
    });
  }
}

if (!customElements.get('nova-recipe-gallery')) {
  customElements.define('nova-recipe-gallery', NovaRecipeGallery);
}
